import type { CreateFlow } from '@/utils/analytics-events';

export interface FormatCopy {
  word: string;
  label: string;
  noun: string;
  cardLine: string;
  stripLine: string;
  switchAsk: string;
  previewSubline: string;
  previewSwitch: string;
  summaryLine: string;
  placeholder: string;
  mismatchTitle: string;
  mismatchBody: string;
  mismatchAccept: string;
  mismatchDismiss: string;
}

export const FORMAT_COPY: Readonly<Record<CreateFlow, FormatCopy>> = {
  'picture-book': {
    word: 'PICTURE BOOK',
    label: 'Picture book',
    noun: 'picture book',
    cardLine: 'Painted pages with story text below, to read aloud.',
    stripLine: 'painted pages, story text below.',
    switchAsk: 'Want a comic instead?',
    previewSubline: 'No panels or speech bubbles.',
    previewSwitch: 'Want a comic?',
    summaryLine: 'painted pages with read-aloud text',
    placeholder: 'Describe your picture-book story…',
    mismatchTitle: 'Sounds like you want a COMIC',
    mismatchBody:
      '(panels and speech bubbles). This flow makes a picture book: painted pages with read-aloud text underneath.',
    mismatchAccept: 'Make it a comic, keep my photo and idea',
    mismatchDismiss: 'No, a picture book is right',
  },
  comic: {
    word: 'COMIC',
    label: 'Comic',
    noun: 'comic',
    cardLine: 'Panels, speech bubbles and sound effects.',
    stripLine: 'panels, speech bubbles, sound effects.',
    switchAsk: 'Want a picture book instead?',
    previewSubline: 'Panels and speech bubbles, not a read-aloud storybook.',
    previewSwitch: 'Want a picture book?',
    summaryLine: 'panels, speech bubbles, sound effects',
    placeholder: 'Describe your comic story: a football final, a trip to space, a dinosaur in the park…',
    mismatchTitle: 'Looking for a PICTURE BOOK?',
    mismatchBody: '(painted pages, story text below). This flow makes a comic: panels and speech bubbles.',
    mismatchAccept: 'Make it a picture book, keep my photo and idea',
    mismatchDismiss: 'No, a comic is right',
  },
};

export function otherFormat(f: CreateFlow): CreateFlow {
  return f === 'comic' ? 'picture-book' : 'comic';
}

export function orderFormatLine(f: CreateFlow, printFormatName: string | null): string {
  const c = FORMAT_COPY[f];
  return `${c.label} · ${c.summaryLine} · ${printFormatName ?? 'Digital PDF'}`;
}
